enum adBlockType {
  None = 'None',
  Popup = 'Popup',
  Carousel = 'Carousel',
}

export default adBlockType;
